/* eslint-disable no-shadow,consistent-return,no-param-reassign */
import apiCompanyLocation from '@/services/jApiLocation';

const state = {
  // Set default state(s) here
  list_company_location: null,
  loading: true,
};

const getters = {
  // Change value of state(s) with getter
};

const mutations = {
  mutateCreateCompanyLocation(state, data) {
    state.error = data;
  },

  mutateListCompanyLocation(state, data) {
    state.list_company_location = data;
  },
};

const actions = {
  async createCompanyLocation({ commit, dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please Wait', { root: true });
    try {
      const res = await apiCompanyLocation.companyCreateLocation(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      commit('mutateCreateCompanyLocation', res);
    } catch (err) {
      if (err.response.data.errors) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.errors[0].message, { root: true });
        throw err;
      } else {
        commit('mutateError');
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      }
    }
  },

  async companyDeleteLocation({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please Wait', { root: true });
    try {
      const res = await apiCompanyLocation.companyDeleteLocation(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      if (err.response.data.errors) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.errors[0].message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      }
    }
  },

  async companyUpdateLocation({ dispatch }, { id, req }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please Wait', { root: true });
    try {
      const res = await apiCompanyLocation.companyUpdateLocation(id, req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      if (err.response.data.errors) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.errors[0].message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      }
    }
  },

  async getListCompanyLocation({ dispatch, commit }, data) {
    try {
      const getListCompanyLocation = await apiCompanyLocation.companyListLocation(data);
      commit('getListCompanyLocation', getListCompanyLocation);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreLocation.js